<div class="layout-topbar">
    <a href="#" class="layout-menubutton" [ngClass]="{'layout-menubutton-active': app.menuActive}" (click)="app.onMenuButtonClick($event)">
        <div class="layout-menubutton-icon">
        </div>
    </a>
    <div class="layout-topbar-grid">
        <div class="layout-topbar-grid-column layout-topbar-grid-column-fixed">
            <a href="/" class="layout-logo" *ngIf="!alertarActualizacion">
                <img src="assets/layout/images/facturar-facil-ecuador.png" alt="fazil-layout" />
            </a>
            <a href="#" pRipple class="p-button p-button-secondary button-2-lines"
               (click)="app.onTopbarInfoMenuButtonClick($event);"
               *ngIf="!alertarActualizacion">
                <span>&nbsp;v{{ appConfig.app.version.id }}</span>
                <span class="p-ink">
                </span>
            </a>
            <a href="#" pRipple class="p-button p-button-danger"
               (click)="app.updateVersion(serverVersionNumber); alertarActualizacion=false;"
               *ngIf="alertarActualizacion">
                <i class="pi pi-refresh"></i>
                <span>&nbsp;Clic para actualizar a v{{ appConfig.app.version.id }}</span>
                <span class="p-ink">
                </span>
            </a>
        </div>
        <div class="layout-topbar-grid-column">
            <app-menu></app-menu>
        </div>
        <div class="layout-topbar-grid-column layout-topbar-grid-column-fixed  hidden-xs-down">
<!--            <p-button label="{{ currentUser.code }} - {{ currentUser.nombre }}" 
                      icon="pi pi-user" 
                      styleClass="p-button p-button-success"
                      (click)="app.onTopbarUserMenuButtonClick($event)"></p-button>-->
            <a href="#" class="p-button p-button-info"
               title="{{ currentUser.code }} - {{ currentUser.initials }}" (click)="app.onTopbarUserMenuButtonClick($event)">
                <i class="pi pi-user"></i>
                <span>&nbsp;{{ currentUser.code }} - {{ currentUser.nombre }}</span>
                <span class="p-ink">
                </span>
            </a>
            <ul class="layout-profile-menu fadeInDown" [ngClass]="{'layout-profile-menu-active': app.topbarUserMenuActive}">
                <li role="menuitem">
                    <a href="#" pRipple class="p-ripple p-element" (click)="app.onTopbarSubItemClickProfile($event)">
                        <i class="pi pi-heart"></i>
                        <span>{{currentUser.initials }} [{{ currentUser.username }}]</span>
                        <span class="p-ink">
                        </span>
                    </a>
                </li>
                <li role="menuitem">
                    <a href="#" pRipple class="p-ripple p-element" (click)="app.onTopbarUserMenuClick($event)">
                        <i class="pi pi-sign-out">
                        </i>
                        <span>Salir</span>
                        <span class="p-ink">
                        </span>
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>